module.exports = __webpack_public_path__ + "static/greenchef-8de61ee60ef886f4a9f8028a1ff35606.png";